export default __webpack_public_path__ + "27c736cbaf550ea2a14d3a33e9ccfc0a.svg";